export default __webpack_public_path__ + "static/media/bg-interna02.bdbd9db9.jpg";